
import { Component, Vue, Prop, Emit } from "vue-property-decorator";
import IntroduceCard from "../components/introduce-card.vue";
import { ExamVersionInfo } from "@/lib/model/exambuilder/exam-component/exam";
import InputNumberV3 from "@/views/ai-builder-v3/components/inputNumberV3.vue";

@Component({
  components: {
    IntroduceCard,
    InputNumberV3
  }
})
export default class ColorDetection extends Vue {
  @Prop() formItemData!: ExamVersionInfo; // 组件数据
  @Prop({ default: "" }) builder!: string; // 创建面试来源

  trialOne() {
    this.$emit("trial", "colorDetection");
  }

  @Emit("setGlobal")
  setGlobal() {
    return;
  }

  // 校验数据
  formItemCheck() {
    return new Promise((resolve, reject) => {
      const valid = true;
      if (valid) {
        resolve("");
      } else {
        resolve("AiAnswer");
      }
    });
  }
}
